<template>
  <!-- Profile & Stats -->
  <div class="profile">
    <section class="profile__player">
      <b-loading :is-full-page="false" v-model="isLoading.player"></b-loading>
      <ProfileCard
        :player="player"
        :level="stats ? stats.level : null"
        type="large"
        :onlinePlayer="onlinePlayer"
        :challenge="getPlayer && username !== getPlayer.username"
        :allowEdit="getPlayer && username === getPlayer.username"
      />
      <section class="profile__stats">
        <b-loading :is-full-page="false" v-model="isLoading.stats"></b-loading>
        <PlayerWinStats v-if="stats" :stats="stats" />
      </section>
    </section>

    <section class="profile__points">
      <b-loading :is-full-page="false" v-model="isLoading.points"></b-loading>
      <router-link to="/leaderboards" v-show="!isLoading.points">
        <b-tooltip label="View Leaderboard" :delay="200">
          <p style="background-color: #223379; line-height: 2rem; color: white">
            <b>POINTS</b>
          </p>
          <table class="table is-narrow is-bordered has-text-left">
            <tbody>
              <tr>
                <td>Today</td>
                <td class="has-text-right has-text-info">
                  <b>{{ points.daily | numberString }}</b>
                </td>
              </tr>
              <tr>
                <td>This Week</td>
                <td class="has-text-right has-text-info">
                  <b>{{ points.weekly | numberString }}</b>
                </td>
              </tr>
              <tr>
                <td>All Time</td>
                <td class="has-text-right has-text-info">
                  <b>{{ points.allTime | numberString }}</b>
                </td>
              </tr>
            </tbody>
          </table>
        </b-tooltip>
      </router-link>
    </section>

    <div class="profile__trophies">
      <PlayerTrophies v-if="stats" :rewards="rewards" />
    </div>
  </div>
</template>

<script>
import ProfileCard from "@/components/players/ProfileCard.vue";
import PlayerWinStats from "./PlayerWinStats.vue";
import PlayerTrophies from "./PlayerTrophies.vue";
import { mapGetters, mapMutations } from "vuex";
import { PlayersAPI, MatchesAPI, LeaderboardsAPI } from "@/services/api";
import { firestore } from "@/services/firebase";

export default {
  components: {
    ProfileCard,
    PlayerWinStats,
    PlayerTrophies,
  },

  props: ["username"],

  data() {
    return {
      player: null,
      stats: null,
      rewards: null,
      points: { loading: 0 },
    };
  },

  computed: {
    ...mapGetters(["getPlayer", "getOnlinePlayers"]),

    isLoading() {
      return {
        player: this.player == null,
        stats: this.stats == null,
        points: this.points.loading < 3,
      };
    },

    onlinePlayer() {
      if (!this.username) return null;
      if (!this.getOnlinePlayers || !this.getOnlinePlayers.length) return null;
      return this.getOnlinePlayers.find((p) => p.username === this.username);
    },

    onlineStatus() {
      if (!this.onlinePlayer) return null;
      return this.onlinePlayer.status;
    },
  },

  watch: {
    username: {
      immediate: true,
      handler(username) {
        if (!username) return;
        if (this.getPlayer && this.getPlayer.username === username) {
          // this is me
          this.player = this.getPlayer;
          if (!this.player.dna) {
            window.location =
              "https://www.chesssquad.com/pages/chess-student/avatar-select.php";
          }
          MatchesAPI.getPlayerRating(username).then((data) => {
            this.stats = data;
            this.setStats(data); // update vuex
            this.player = { ...this.player, stats: data };
          });
        } else {
          // another player
          PlayersAPI.getPlayer(this.username).then((data) => {
            this.player = data;
            MatchesAPI.getPlayerRating(username).then((data) => {
              this.stats = data;
              this.player = { ...this.player, stats: data };
            });
          });
        }

        this.$bind(
          "rewards",
          firestore
            .collection("metadata")
            .doc(username)
            .collection("rewards")
        );

        // Query points
        LeaderboardsAPI.get({
          Type: "Students",
          Space: "Student",
          SpaceCode: this.username,
          PeriodTYpe: "Daily",
          Limit: 1,
        }).then((data) => {
          if (data.ranks && data.ranks.length) {
            this.points.daily = data.ranks[0].score;
          }
          ++this.points.loading;
        });
        LeaderboardsAPI.get({
          Type: "Students",
          Space: "Student",
          SpaceCode: this.username,
          PeriodTYpe: "Weekly",
          Limit: 1,
        }).then((data) => {
          if (data.ranks && data.ranks.length) {
            this.points.weekly = data.ranks[0].score;
          }
          ++this.points.loading;
        });
        LeaderboardsAPI.get({
          Type: "Students",
          Space: "Student",
          SpaceCode: this.username,
          PeriodTYpe: "AllTime",
          Limit: 1,
        }).then((data) => {
          if (data.ranks && data.ranks.length) {
            this.points.allTime = data.ranks[0].score;
          }
          ++this.points.loading;
        });
      },
    },
  },

  filters: {
    numberString(number) {
      if (!number) return "-";
      return Number(number).toLocaleString();
    },
  },

  methods: {
    ...mapMutations(["setStats"]),
  },
};
</script>

<style scoped>
@media only screen and (max-width: 600px) {
  .profile {
    flex-direction: column;
    align-items: center !important;
  }
}

.profile {
  margin: 0;
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: flex-start;
}

.profile__player {
  /* margin: 10px 0; */
  min-width: 300px;
  position: relative;
}

.profile__stats {
  width: 200px;
  margin-left: 138px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}

.profile__points {
  /* margin: 15px 0; */
  position: relative;
}

.profile__trophies {
  flex: 0.8;
}
</style>
